<template>
  <div
    class="draw-view"
    :class="`draw-view__theme-${draw.theme}`"
    :style="{ '--accent--color': draw.style.color ? hexToRgb(draw.style.color) : null }"
  >
    <loader v-if="loader"></loader>
    <div class="background-container">
      <div class="background-stretch container-fulid">
        <div class="background-stretch row no-gutters justify-content-center">
          <div class="background-stretch col col-md-6 col-lg-4">
            <div
              class="background" :class="{ 'background__step-2': currentStep === 2, 'background__step-3': currentStep === 3 }"
              :style="draw.style.bg ? `background-image: url(${draw.style.bg})` : null"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="header">
      <div class="container-fulid">
        <div class="row no-gutters justify-content-center">
          <div class="col col-md-6 col-lg-4">
            <div class="steps">
              <div class="bar" :class="{ 'bar__is-active': currentStep >= 1 }" />
              <div class="bar" :class="{ 'bar__is-active': currentStep >= 2 }" />
              <div class="bar" :class="{ 'bar__is-active': currentStep >= 3 }" />
            </div>
            <div class="info">
              <div class="brand">
                <div class="logo">
                  <img :src="brand.logo">
                </div>
                <div class="name">{{ brand.name }}</div>
              </div>
              <div class="powered-by">
                <svg width="60px" height="27px" viewBox="0 0 60 27" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.50265067">
                    <g transform="translate(-300.000000, -24.000000)" fill="#FFFFFF" fill-rule="nonzero">
                      <g transform="translate(300.000000, 24.000000)">
                          <path d="M2.184,0.064 C2.909337,0.064 3.4799979,0.2373316 3.896,0.584 C4.3120021,0.9306684 4.52,1.40799696 4.52,2.016 C4.52,2.62400304 4.3120021,3.1013316 3.896,3.448 C3.4799979,3.7946684 2.909337,3.968 2.184,3.968 L0.8,3.968 L0.8,5.664 L0,5.664 L0,0.064 L2.184,0.064 Z M2.16,3.272 C2.6666692,3.272 3.053332,3.16400108 3.32,2.948 C3.586668,2.73199892 3.72,2.42133536 3.72,2.016 C3.72,1.61066464 3.586668,1.30000108 3.32,1.084 C3.053332,0.86799892 2.6666692,0.76 2.16,0.76 L0.8,0.76 L0.8,3.272 L2.16,3.272 Z M8.5897143,5.728 C8.0243781,5.728 7.5150499,5.60400124 7.0617143,5.356 C6.6083787,5.10799876 6.2523822,4.76533552 5.9937143,4.328 C5.7350463,3.89066448 5.6057143,3.40266936 5.6057143,2.864 C5.6057143,2.32533064 5.7350463,1.83733552 5.9937143,1.4 C6.2523822,0.96266448 6.6083787,0.62000124 7.0617143,0.372 C7.5150499,0.12399876 8.0243781,0 8.5897143,0 C9.1497171,0 9.6563787,0.12399876 10.1097143,0.372 C10.5630499,0.62000124 10.917713,0.96133116 11.1737143,1.396 C11.4297155,1.83066884 11.5577143,2.31999728 11.5577143,2.864 C11.5577143,3.40800272 11.4297155,3.89733116 11.1737143,4.332 C10.917713,4.76666884 10.5630499,5.10799876 10.1097143,5.356 C9.6563787,5.60400124 9.1497171,5.728 8.5897143,5.728 Z M8.5897143,5.016 C9.000383,5.016 9.3697126,4.9226676 9.6977143,4.736 C10.0257159,4.5493324 10.28438,4.29200164 10.4737143,3.964 C10.6630485,3.63599836 10.7577143,3.26933536 10.7577143,2.864 C10.7577143,2.45866464 10.6630485,2.09200164 10.4737143,1.764 C10.28438,1.43599836 10.0257159,1.1786676 9.6977143,0.992 C9.3697126,0.8053324 9.000383,0.712 8.5897143,0.712 C8.1790455,0.712 7.8070493,0.8053324 7.4737143,0.992 C7.1403793,1.1786676 6.8790485,1.43599836 6.6897143,1.764 C6.50038,2.09200164 6.4057143,2.45866464 6.4057143,2.864 C6.4057143,3.26933536 6.50038,3.63599836 6.6897143,3.964 C6.8790485,4.29200164 7.1403793,4.5493324 7.4737143,4.736 C7.8070493,4.9226676 8.1790455,5.016 8.5897143,5.016 Z M20.8034285,0.064 L18.9314285,5.664 L18.0914285,5.664 L16.5634285,1.192 L15.0354285,5.664 L14.1794285,5.664 L12.3074285,0.064 L13.1314285,0.064 L14.6434285,4.616 L16.2194285,0.064 L16.9554285,0.064 L18.4994285,4.64 L20.0434285,0.064 L20.8034285,0.064 Z M26.1291428,4.968 L26.1291428,5.664 L22.0651428,5.664 L22.0651428,0.064 L26.0171428,0.064 L26.0171428,0.76 L22.8651428,0.76 L22.8651428,2.48 L25.6731428,2.48 L25.6731428,3.16 L22.8651428,3.16 L22.8651428,4.968 L26.1291428,4.968 Z M31.4548571,5.664 L30.2468571,3.944 C30.097523,3.95466672 29.9801908,3.96 29.8948571,3.96 L28.5108571,3.96 L28.5108571,5.664 L27.7108571,5.664 L27.7108571,0.064 L29.8948571,0.064 C30.620194,0.064 31.190855,0.2373316 31.6068571,0.584 C32.0228592,0.9306684 32.2308571,1.40799696 32.2308571,2.016 C32.2308571,2.44800216 32.1241915,2.81599848 31.9108571,3.12 C31.6975227,3.42400152 31.3935257,3.64533264 30.9988571,3.784 L32.3268571,5.664 L31.4548571,5.664 Z M29.8708571,3.28 C30.3775263,3.28 30.7641891,3.17066776 31.0308571,2.952 C31.2975251,2.73333224 31.4308571,2.42133536 31.4308571,2.016 C31.4308571,1.61066464 31.2975251,1.30000108 31.0308571,1.084 C30.7641891,0.86799892 30.3775263,0.76 29.8708571,0.76 L28.5108571,0.76 L28.5108571,3.28 L29.8708571,3.28 Z M37.8765713,4.968 L37.8765713,5.664 L33.8125713,5.664 L33.8125713,0.064 L37.7645713,0.064 L37.7645713,0.76 L34.6125713,0.76 L34.6125713,2.48 L37.4205713,2.48 L37.4205713,3.16 L34.6125713,3.16 L34.6125713,4.968 L37.8765713,4.968 Z M39.4582856,0.064 L41.8182856,0.064 C42.4102886,0.064 42.9356167,0.18133216 43.3942856,0.416 C43.8529546,0.65066784 44.208951,0.97999788 44.4622856,1.404 C44.7156202,1.82800212 44.8422856,2.31466392 44.8422856,2.864 C44.8422856,3.41333608 44.7156202,3.89999788 44.4622856,4.324 C44.208951,4.74800212 43.8529546,5.07733216 43.3942856,5.312 C42.9356167,5.54666784 42.4102886,5.664 41.8182856,5.664 L39.4582856,5.664 L39.4582856,0.064 Z M41.7702856,4.968 C42.2236212,4.968 42.6222839,4.88000088 42.9662856,4.704 C43.3102873,4.52799912 43.575618,4.28133492 43.7622856,3.964 C43.9489532,3.64666508 44.0422856,3.28000208 44.0422856,2.864 C44.0422856,2.44799792 43.9489532,2.08133492 43.7622856,1.764 C43.575618,1.44666508 43.3102873,1.20000088 42.9662856,1.024 C42.6222839,0.84799912 42.2236212,0.76 41.7702856,0.76 L40.2582856,0.76 L40.2582856,4.968 L41.7702856,4.968 Z M52.5577141,2.76 C52.8830491,2.85066712 53.1390465,3.01466548 53.3257141,3.252 C53.5123817,3.48933452 53.6057141,3.78933152 53.6057141,4.152 C53.6057141,4.63733576 53.4230493,5.01066536 53.0577141,5.272 C52.692379,5.53333464 52.1603843,5.664 51.4617141,5.664 L48.7897141,5.664 L48.7897141,0.064 L51.3017141,0.064 C51.9417173,0.064 52.4363791,0.19199872 52.7857141,0.448 C53.1350492,0.70400128 53.3097141,1.0586644 53.3097141,1.512 C53.3097141,1.8053348 53.2417148,2.0586656 53.1057141,2.272 C52.9697135,2.4853344 52.7870486,2.64799944 52.5577141,2.76 Z M49.5897141,0.712 L49.5897141,2.504 L51.2297141,2.504 C51.6403829,2.504 51.9563797,2.42800076 52.1777141,2.276 C52.3990486,2.12399924 52.5097141,1.9013348 52.5097141,1.608 C52.5097141,1.3146652 52.3990486,1.09200076 52.1777141,0.94 C51.9563797,0.78799924 51.6403829,0.712 51.2297141,0.712 L49.5897141,0.712 Z M51.4297141,5.016 C51.8830497,5.016 52.2243797,4.94133408 52.4537141,4.792 C52.6830486,4.64266592 52.7977141,4.4080016 52.7977141,4.088 C52.7977141,3.46399688 52.3417187,3.152 51.4297141,3.152 L49.5897141,3.152 L49.5897141,5.016 L51.4297141,5.016 Z M57.1554284,3.728 L57.1554284,5.664 L56.3634284,5.664 L56.3634284,3.712 L54.1394284,0.064 L54.9954284,0.064 L56.7874284,3.016 L58.5874284,0.064 L59.3794284,0.064 L57.1554284,3.728 Z" id="Shape"></path>
                          <path d="M13.1601204,24.0440566 C13.839974,23.6616858 14.3739659,23.1275688 14.762722,22.4414549 C15.1511025,21.7558419 15.3455431,20.9878452 15.3455431,20.1378403 C15.3455431,19.288211 15.1511025,18.5202143 14.762722,17.8341005 C14.3739659,17.1483623 13.839974,16.6139948 13.1601204,16.2316241 C12.4800163,15.8491281 11.7152748,15.6579428 10.8656456,15.6579428 C10.0156407,15.6579428 9.250774,15.8491281 8.5710456,16.2316241 C7.8909415,16.6139948 7.3568244,17.1483623 6.9684439,17.8341005 C6.5796879,18.5202143 6.385748,19.288211 6.385748,20.1378403 C6.385748,20.9878452 6.5796879,21.7558419 6.9684439,22.4414549 C7.3568244,23.1275688 7.8909415,23.6616858 8.5710456,24.0440566 C9.250774,24.4265525 10.0156407,24.6177379 10.8656456,24.6177379 C11.7152748,24.6177379 12.4800163,24.4265525 13.1601204,24.0440566 M7.3509399,25.8469834 C6.3066196,25.2824419 5.4871643,24.4994208 4.8924488,23.4977948 C4.2973578,22.4961688 4,21.3761005 4,20.1378403 C4,18.899455 4.2973578,17.7795119 4.8924488,16.7778859 C5.4871643,15.776385 6.3066196,14.9932387 7.3509399,14.4286972 C8.3947594,13.8641558 9.5664114,13.5818224 10.8656456,13.5818224 C12.1645041,13.5818224 13.3360309,13.8641558 14.3803513,14.4286972 C15.424296,14.9932387 16.2438765,15.7733802 16.8388423,16.7688712 C17.4335578,17.7644875 17.7311659,18.8874355 17.7311659,20.1378403 C17.7311659,21.3883704 17.4335578,22.5115688 16.8388423,23.5069346 C16.2438765,24.5024257 15.424296,25.2824419 14.3803513,25.8469834 C13.3360309,26.4115249 12.1645041,26.693733 10.8656456,26.693733 C9.5664114,26.693733 8.3947594,26.4115249 7.3509399,25.8469834 M21.3186272,26.0018223 C20.5173264,25.5768824 19.8918109,24.9850466 19.4429573,24.2261897 C18.9936028,23.4675832 18.7691134,22.6084385 18.7691134,21.6492564 C18.7691134,20.6904499 18.9936028,19.8344353 19.4429573,19.0817133 C19.8918109,18.3289914 20.5141963,17.7402857 21.3094874,17.3150955 C22.104528,16.890406 23.0121264,16.6776857 24.0320321,16.6776857 C24.9909638,16.6776857 25.8318288,16.8721263 26.5542516,17.2605068 C27.2764239,17.6491377 27.8199313,18.207419 28.1841475,18.9358515 L26.4359345,19.9557572 C26.1564809,19.5066531 25.8076646,19.1698564 25.3887345,18.9449914 C24.9699296,18.720502 24.5115605,18.6080694 24.0137524,18.6080694 C23.1638727,18.6080694 22.4596044,18.884393 21.9013231,19.4366645 C21.3427914,19.9893117 21.0637134,20.726884 21.0637134,21.6492564 C21.0637134,22.5721296 21.3396613,23.3097019 21.8921833,23.8619735 C22.44458,24.4144954 23.151728,24.6905686 24.0137524,24.6905686 C24.5115605,24.6905686 24.9699296,24.5785117 25.3887345,24.3536466 C25.8076646,24.1291572 26.1564809,23.7923605 26.4359345,23.343006 L28.1841475,24.3627865 C27.8076613,25.0913442 27.2581443,25.6528808 26.5360971,26.047271 C25.8135492,26.4420369 24.9789443,26.639232 24.0320321,26.639232 C23.0241459,26.639232 22.1198028,26.4268873 21.3186272,26.0018223 M34.8948665,24.5904686 C35.3379609,24.329545 35.6505934,23.9561889 35.8327641,23.4705255 L35.8327641,22.3413174 L33.4835755,22.3413174 C32.1723218,22.3413174 31.5167576,22.7723922 31.5167576,23.6342914 C31.5167576,24.0472117 31.6806487,24.3749938 32.0084308,24.6177629 C32.3362129,24.8606572 32.7914519,24.9819792 33.3741479,24.9819792 C33.9448243,24.9819792 34.4515218,24.8516426 34.8948665,24.5904686 M36.9709869,17.7066686 C37.7295934,18.3926572 38.1090844,19.4275873 38.1090844,20.811584 L38.1090844,26.5117125 L35.960221,26.5117125 L35.960221,25.328041 C35.6807674,25.753106 35.2833722,26.077758 34.7674096,26.3022475 C34.2511966,26.5267369 33.6293121,26.6391694 32.9007544,26.6391694 C32.1723218,26.6391694 31.5349121,26.514467 30.9886503,26.2658133 C30.4422633,26.0171597 30.0202031,25.6710979 29.7229706,25.2278784 C29.4252373,24.784784 29.2767462,24.283971 29.2767462,23.7254393 C29.2767462,22.8512702 29.6015235,22.150132 30.2510779,21.6220247 C30.9005072,21.0939174 31.9234178,20.8298637 33.3196844,20.8298637 L35.8327641,20.8298637 L35.8327641,20.6841271 C35.8327641,20.0043987 35.6293088,19.4821759 35.2226487,19.1179597 C34.8157381,18.7538686 34.212008,18.5716979 33.4107072,18.5716979 C32.8643202,18.5716979 32.3270731,18.6567109 31.7989657,18.8266117 C31.2709836,18.9967629 30.8247592,19.2335223 30.460543,19.5368897 L29.5682194,17.8795743 C30.078047,17.491319 30.6910422,17.1939613 31.4074552,16.9872507 C32.1236178,16.781041 32.8825999,16.6777483 33.6837755,16.6777483 C35.1163511,16.6777483 36.21213,17.0209304 36.9709869,17.7066686 M55.9193828,13 L55.9193828,26.5124358 L53.7340853,26.5124358 L53.7340853,25.2558959 C53.3575991,25.7175203 52.8932202,26.0634569 52.3409487,26.2939561 C51.7883015,26.5244553 51.1783113,26.6400179 50.5107275,26.6400179 C49.5757096,26.6400179 48.735095,26.4335577 47.9886332,26.0208878 C47.241921,25.6082179 46.6559698,25.0222666 46.2311552,24.2634097 C45.8060901,23.5048032 45.5938706,22.6335138 45.5938706,21.6500423 C45.5938706,20.6668211 45.8060901,19.798787 46.2311552,19.046065 C46.6559698,18.2933431 47.241921,17.7106472 47.9886332,17.2977268 C48.735095,16.8851821 49.5757096,16.6784715 50.5107275,16.6784715 C51.154147,16.6784715 51.7428527,16.787774 52.2773454,17.0063789 C52.8113373,17.2248585 53.2665763,17.5526407 53.6430625,17.9897252 L53.6430625,13 L55.9193828,13 Z M45.2295186,16.6777233 L45.2295186,18.8448663 C45.0352031,18.8084322 44.8590422,18.7901525 44.7014113,18.7901525 C43.8150974,18.7901525 43.1230991,19.0483216 42.6254161,19.5642842 C42.1274828,20.080372 41.8787039,20.8238289 41.8787039,21.7950305 L41.8787039,26.5116875 L39.6023836,26.5116875 L39.6023836,16.7870257 L41.7694015,16.7870257 L41.7694015,18.2074566 C42.4250909,17.1876761 43.5783381,16.6777233 45.2295186,16.6777233 Z M50.783921,18.6088553 C50.237534,18.6088553 49.7459861,18.7334325 49.3089015,18.9822114 C48.8716918,19.2312407 48.5258804,19.5863171 48.2708414,20.0475659 C48.0158023,20.509065 47.8884706,21.0431821 47.8884706,21.6500423 C47.8884706,22.2574033 48.0158023,22.7915203 48.2708414,23.2526439 C48.5258804,23.7142683 48.8716918,24.0693447 49.3089015,24.3179984 C49.7459861,24.5670276 50.237534,24.6913545 50.783921,24.6913545 C51.330308,24.6913545 51.8219812,24.5670276 52.2590657,24.3179984 C52.6960251,24.0693447 53.0420869,23.7142683 53.2970007,23.2526439 C53.5520397,22.7915203 53.6794966,22.2574033 53.6794966,21.6500423 C53.6794966,21.0431821 53.5520397,20.509065 53.2970007,20.0475659 C53.0420869,19.5863171 52.6960251,19.2312407 52.2590657,18.9822114 C51.8219812,18.7334325 51.330308,18.6088553 50.783921,18.6088553 Z" id="Shape"></path>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="main-stretch container-fulid">
        <div class="main-stretch row no-gutters justify-content-center">
          <div class="main-stretch col col-md-6 col-lg-4">
            <transition name="slide" mode="out-in">
              <div class="draw-step draw-step-1" v-if="currentStep === 1" key="draw-step-1">
                <div class="title">{{ draw.title }}</div>
                <template
                  v-if="draw.descImage"
                >
                  <img class="desc-image" :src="draw.descImage">
                </template>
                <template v-else>
                  <div class="desc">{{ draw.desc }}</div>
                  <div class="subtitle">・{{ $t('draw.greatPrizes') }}・</div>
                  <div class="prizes">
                    <swiper class="prizes-wrapper" :options="swiperOptions" v-if="!loader">
                      <swiper-slide
                        class="prize"
                        :style="{
                          background: draw.style.color ? 'none' : null,
                          backgroundColor: `#${draw.style.color}` || null,
                          boxShadow: draw.style.color ? 'none' : null,
                        }"
                        v-for="(prize, index) in draw.prizes"
                        v-bind:key="`prize#${index}`"
                      >
                        <div class="image">
                          <img :src="prize.image">
                        </div>
                        <div class="name">{{ prize.name }}</div>
                      </swiper-slide>
                    </swiper>
                  </div>
                </template>
                <button class="btn" v-on:click="goPlay">{{ $t('draw.startPlay') }} <span class="icon material-icons">arrow_forward</span></button>
                <div v-if="$t('draw.acceptingOfTerms')" class="terms"></div>
                <div class="token monospace" v-if="draw.id">{{ $t('draw.serial') }} {{ draw.id }}</div>
                <i18n-picker></i18n-picker>
              </div>
              <div class="draw-step draw-step-2" v-else-if="currentStep === 2" key="draw-step-2">
                <div class="title">{{ draw.title }}</div>
                <!-- 刮刮卡 -->
                <template v-if="draw.type === 1">
                  <div class="game">
                    <div class="scratch-off-ticket">
                      <div class="overlay">
                        <div class="overlay-position">
                          <div class="canvas-box" :style="`background-image: url(${draw.result.image})`">
                            <canvas ref="canvas"></canvas>
                          </div>
                          <div class="ticket-background">
                            <svg width="100%" height="100%" viewBox="0 0 345 345" xmlns="http://www.w3.org/2000/svg"><title>Ticket</title><path id="scratch_area" d="M4.004 0C1.794 0 0 1.794 0 3.994v337.012C0 343.212 1.787 345 4 345h15.937c.332-3.353 3.16-5.97 6.6-5.97 3.442 0 6.27 2.617 6.603 5.97h13.335c.333-3.353 3.162-5.97 6.602-5.97 3.44 0 6.27 2.617 6.602 5.97h13.334c.332-3.353 3.16-5.97 6.6-5.97 3.442 0 6.27 2.617 6.603 5.97h13.335c.333-3.353 3.162-5.97 6.602-5.97 3.44 0 6.27 2.617 6.602 5.97h13.334c.333-3.353 3.162-5.97 6.602-5.97 3.44 0 6.27 2.617 6.602 5.97h13.335c.332-3.353 3.16-5.97 6.6-5.97 3.44 0 6.27 2.617 6.603 5.97h13.334c.333-3.353 3.162-5.97 6.602-5.97 3.44 0 6.268 2.617 6.6 5.97h13.336c.333-3.353 3.16-5.97 6.602-5.97 3.44 0 6.27 2.617 6.602 5.97h13.334c.333-3.353 3.162-5.97 6.602-5.97 3.44 0 6.27 2.617 6.602 5.97h13.335c.333-3.353 3.16-5.97 6.602-5.97 3.44 0 6.27 2.617 6.6 5.97h13.336c.334-3.353 3.163-5.97 6.603-5.97s6.27 2.617 6.602 5.97h13.335c.333-3.353 3.16-5.97 6.602-5.97 3.44 0 6.27 2.617 6.6 5.97h15.94c2.208 0 3.998-1.794 3.998-3.994V3.994C345 1.788 343.216 0 340.996 0h-15.9c0 3.664-2.97 6.635-6.634 6.635-3.665 0-6.635-2.97-6.635-6.635h-13.27c0 3.664-2.97 6.635-6.634 6.635s-6.635-2.97-6.635-6.635h-13.27c0 3.664-2.97 6.635-6.633 6.635-3.665 0-6.635-2.97-6.635-6.635h-13.27c0 3.664-2.97 6.635-6.634 6.635s-6.634-2.97-6.634-6.635h-13.27c0 3.664-2.97 6.635-6.634 6.635-3.665 0-6.635-2.97-6.635-6.635h-13.27c0 3.664-2.97 6.635-6.634 6.635-3.665 0-6.635-2.97-6.635-6.635h-13.27c0 3.664-2.97 6.635-6.634 6.635-3.663 0-6.634-2.97-6.634-6.635h-13.27c0 3.664-2.97 6.635-6.634 6.635s-6.634-2.97-6.634-6.635h-13.27c0 3.664-2.97 6.635-6.634 6.635S99.52 3.665 99.52 0H86.25c0 3.664-2.97 6.635-6.635 6.635-3.664 0-6.634-2.97-6.634-6.635H59.713c0 3.664-2.97 6.635-6.635 6.635-3.664 0-6.635-2.97-6.635-6.635h-13.27c0 3.664-2.97 6.635-6.634 6.635S19.904 3.665 19.904 0h-15.9z" fill="#a11ae1" fill-rule="evenodd"/></svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>

                <!-- 四選一 -->
                <template v-if="draw.type === 2">
                  <div class="game">
                    <div class="flip-cards">
                      <div
                        class="flip-card"
                        v-on:click="onClickFlipCard(index - 1)"
                        v-for="index in 4"
                        v-bind:key="index"
                        ref="flipCard"
                      >
                        <div class="inner">
                          <div class="front" :style="`background-image: url(${flipCardImage(index)})`" />
                          <div class="back" :style="`background-image: url(${draw.result.image})`" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="desc">{{ $t('draw.choosePrize') }}</div>
                </template>

                <template v-if="draw.type === 3">
                  <div class="game">
                    <div class="swapper" :style="{ background: draw.style.color || null, backgroundColor: `#${draw.style.color}` || null }">
                      <button class="stop" v-on:click="onClickSwapperStop" v-show="showStop">{{ $t('draw.stop') }}</button>
                    </div>
                  </div>
                  <div class="desc">{{ $t('draw.clickStop') }}<br>{{ $t('draw.shotDesc') }}</div>
                </template>

                <!-- 轉盤 -->
                <template v-if="draw.type === 4">
                  <div class="game">
                    <div class="wheel-container position-relative">
                      <div class="wheel position-absolute">
                        <svg class="w-100 h-100" width="5341" height="5660" viewBox="0 0 5341 5660" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2070 160C2070 71.6344 2141.63 0 2230 0H3110C3198.36 0 3270 71.6344 3270 160V559.999H2070V160Z" fill="white"/>
                          <path d="M3270 409.641C3270 492.957 3162.55 560.498 3030 560.498L2310 560.498C2177.45 560.498 2070 492.957 2070 409.641L2070 208.498L3270 208.498L3270 409.641Z" fill="black" fill-opacity="0.05"/>
                          <path d="M3270 439.641C3270 506.388 3162.55 560.498 3030 560.498L2310 560.498C2177.45 560.498 2070 506.388 2070 439.641L2070 278.498L3270 278.498L3270 439.641Z" fill="black" fill-opacity="0.07"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M2670.4 5659.29C4145.22 5659.29 5340.8 4463.72 5340.8 2988.9C5340.8 1514.08 4145.22 318.498 2670.4 318.498C1195.58 318.498 0 1514.08 0 2988.9C0 4463.72 1195.58 5659.29 2670.4 5659.29ZM2768 5422.5C4031.63 5422.5 5056 4398.12 5056 3134.5C5056 1870.87 4031.63 846.498 2768 846.498C1504.37 846.498 480 1870.87 480 3134.5C480 4398.12 1504.37 5422.5 2768 5422.5Z" fill="black" fill-opacity="0.08"/>
                          <path :stroke="`#${draw.style.color}` || '#FFB000'" d="M5148.8 2988.9C5148.8 4357.68 4039.18 5467.29 2670.4 5467.29C1301.62 5467.29 192 4357.68 192 2988.9C192 1620.11 1301.62 510.498 2670.4 510.498C4039.18 510.498 5148.8 1620.11 5148.8 2988.9Z" stroke-width="384"/>
                          <path d="M5308.8 2988.9C5308.8 4446.04 4127.55 5627.29 2670.4 5627.29C1213.25 5627.29 32 4446.04 32 2988.9C32 1531.75 1213.25 350.498 2670.4 350.498C4127.55 350.498 5308.8 1531.75 5308.8 2988.9Z" stroke-opacity="0.2" stroke-width="64"/>
                          <circle cx="2670" cy="2988.5" r="2334" stroke="black" stroke-opacity="0.3" stroke-width="96"/>
                          <circle cx="2670" cy="2988.5" r="2254" stroke="black" stroke-opacity="0.05" stroke-width="64"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M4296.01 951.442C3850.32 595.375 3285.22 382.498 2670.4 382.498C1230.93 382.498 64 1549.42 64 2988.9C64 3412.3 164.96 3812.13 344.119 4165.61L522.551 4020.49C372.232 3708.26 288 3358.22 288 2988.5C288 1672.96 1354.46 606.498 2670 606.498C3214.49 606.498 3716.31 789.189 4117.51 1096.62L4296.01 951.442Z" fill="white" fill-opacity="0.3"/>
                          <path d="M2670 3228.5C2802.55 3228.5 2910 3121.05 2910 2988.5C2910 2855.95 2802.55 2748.5 2670 2748.5C2537.45 2748.5 2430 2855.95 2430 2988.5C2430 3121.05 2537.45 3228.5 2670 3228.5Z" fill="black" fill-opacity="0.1"/>
                          <path d="M2673.76 3176.87C2776.76 3176.87 2860.26 3093.37 2860.26 2990.38C2860.26 2887.38 2776.76 2803.88 2673.76 2803.88C2570.76 2803.88 2487.27 2887.38 2487.27 2990.38C2487.27 3093.37 2570.76 3176.87 2673.76 3176.87Z" fill="#FFB000"/>
                          <path :fill="`#${this.draw.style.color}` || '#FFB000'" d="M2673.76 3176.87C2776.76 3176.87 2860.26 3093.37 2860.26 2990.38C2860.26 2887.38 2776.76 2803.88 2673.76 2803.88C2570.76 2803.88 2487.27 2887.38 2487.27 2990.38C2487.27 3093.37 2570.76 3176.87 2673.76 3176.87Z"/>
                          <ellipse cx="2616.71" cy="2907.61" rx="97.1773" ry="49.107" transform="rotate(-34.0689 2616.71 2907.61)" fill="white" fill-opacity="0.4"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M2821.99 2939.49C2821.99 3042.49 2738.49 3125.99 2635.5 3125.99C2586.03 3125.99 2541.06 3106.73 2507.68 3075.3C2538.58 3135.6 2601.35 3176.87 2673.76 3176.87C2776.76 3176.87 2860.26 3093.37 2860.26 2990.38C2860.26 2936.84 2837.7 2888.58 2801.58 2854.57C2814.63 2880.04 2821.99 2908.91 2821.99 2939.49Z" fill="black" fill-opacity="0.1"/>
                          <path d="M174 2936.5C202.719 2936.5 226 2959.78 226 2988.5C226 3017.22 202.719 3040.5 174 3040.5C145.281 3040.5 122 3017.22 122 2988.5C122 2959.78 145.281 2936.5 174 2936.5Z" fill="white" fill-opacity="0.8"/>
                          <path d="M5166 2936.5C5194.72 2936.5 5218 2959.78 5218 2988.5C5218 3017.22 5194.72 3040.5 5166 3040.5C5137.28 3040.5 5114 3017.22 5114 2988.5C5114 2959.78 5137.28 2936.5 5166 2936.5Z" fill="white" fill-opacity="0.8"/>
                          <path d="M2722 492.498C2722 521.217 2698.72 544.498 2670 544.498C2641.28 544.498 2618 521.217 2618 492.498C2618 463.779 2641.28 440.498 2670 440.498C2698.72 440.498 2722 463.779 2722 492.498Z" fill="white" fill-opacity="0.8"/>
                          <path d="M2722 5484.5C2722 5513.21 2698.72 5536.5 2670 5536.5C2641.28 5536.5 2618 5513.21 2618 5484.5C2618 5455.78 2641.28 5432.5 2670 5432.5C2698.72 5432.5 2722 5455.78 2722 5484.5Z" fill="white" fill-opacity="0.8"/>
                          <path d="M941.824 1186.79C962.132 1207.1 962.132 1240.02 941.824 1260.33C921.517 1280.64 888.592 1280.64 868.285 1260.33C847.978 1240.02 847.978 1207.1 868.285 1186.79C888.592 1166.48 921.517 1166.48 941.824 1186.79Z" fill="white" fill-opacity="0.8"/>
                          <path d="M4471.71 4716.66C4492.02 4736.97 4492.02 4769.89 4471.71 4790.2C4451.41 4810.51 4418.48 4810.51 4398.18 4790.2C4377.87 4769.89 4377.87 4736.97 4398.18 4716.66C4418.48 4696.35 4451.41 4696.35 4471.71 4716.66Z" fill="white" fill-opacity="0.8"/>
                          <path d="M4471.71 1260.33C4451.4 1280.64 4418.48 1280.64 4398.17 1260.33C4377.86 1240.02 4377.86 1207.1 4398.17 1186.79C4418.48 1166.48 4451.4 1166.48 4471.71 1186.79C4492.01 1207.1 4492.01 1240.02 4471.71 1260.33Z" fill="white" fill-opacity="0.8"/>
                          <path d="M941.832 4790.2C921.525 4810.51 888.6 4810.51 868.293 4790.2C847.986 4769.9 847.986 4736.97 868.293 4716.66C888.6 4696.36 921.525 4696.36 941.832 4716.66C962.139 4736.97 962.139 4769.9 941.832 4790.2Z" fill="white" fill-opacity="0.8"/>
                          <mask id="path-23-outside-1_182_1484" maskUnits="userSpaceOnUse" x="2542" y="48.7578" width="256" height="1047" fill="black">
                          <rect fill="white" x="2542" y="48.7578" width="256" height="1047"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M2566.94 192.18C2567.02 192.18 2567.09 192.108 2567.07 192.028C2566.37 187.131 2566.01 182.124 2566.01 177.032C2566.01 119.443 2612.57 72.7578 2670 72.7578C2727.44 72.7578 2774 119.443 2774 177.032C2774 182.162 2773.63 187.206 2772.92 192.137C2772.91 192.16 2772.93 192.18 2772.95 192.18C2772.98 192.18 2772.99 192.199 2772.99 192.221L2695.79 1047.22C2692.94 1078.77 2646.85 1078.77 2644 1047.22L2566.81 192.325C2566.8 192.247 2566.86 192.18 2566.94 192.18Z"/>
                          </mask>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M2566.94 192.18C2567.02 192.18 2567.09 192.108 2567.07 192.028C2566.37 187.131 2566.01 182.124 2566.01 177.032C2566.01 119.443 2612.57 72.7578 2670 72.7578C2727.44 72.7578 2774 119.443 2774 177.032C2774 182.162 2773.63 187.206 2772.92 192.137C2772.91 192.16 2772.93 192.18 2772.95 192.18C2772.98 192.18 2772.99 192.199 2772.99 192.221L2695.79 1047.22C2692.94 1078.77 2646.85 1078.77 2644 1047.22L2566.81 192.325C2566.8 192.247 2566.86 192.18 2566.94 192.18Z" fill="#EDEDED"/>
                          <path d="M2566.81 192.325L2542.91 194.484L2566.81 192.325ZM2772.99 192.221L2749.09 190.063L2772.99 192.221ZM2772.92 192.137L2749.16 188.7L2772.92 192.137ZM2695.79 1047.22L2719.69 1049.38L2695.79 1047.22ZM2644 1047.22L2667.91 1045.06L2644 1047.22ZM2567.07 192.028L2543.32 195.44L2567.07 192.028ZM2590.01 177.032C2590.01 180.979 2590.29 184.845 2590.83 188.615L2543.32 195.44C2542.45 189.416 2542.01 183.269 2542.01 177.032H2590.01ZM2670 96.7578C2625.88 96.7578 2590.01 132.637 2590.01 177.032H2542.01C2542.01 106.248 2599.25 48.7578 2670 48.7578V96.7578ZM2750 177.032C2750 132.637 2714.12 96.7578 2670 96.7578V48.7578C2740.75 48.7578 2798 106.248 2798 177.032H2750ZM2749.16 188.7C2749.71 184.903 2750 181.008 2750 177.032H2798C2798 183.316 2797.55 189.508 2796.67 195.575L2749.16 188.7ZM2671.89 1045.06L2749.09 190.063L2796.89 194.379L2719.69 1049.38L2671.89 1045.06ZM2590.71 190.167L2667.91 1045.06L2620.1 1049.38L2542.91 194.484L2590.71 190.167ZM2542.91 194.484C2541.63 180.354 2552.76 168.18 2566.94 168.18V216.18C2580.97 216.18 2591.97 204.14 2590.71 190.167L2542.91 194.484ZM2772.95 168.18C2787.07 168.18 2798.17 180.299 2796.89 194.379L2749.09 190.063C2747.82 204.098 2758.88 216.18 2772.95 216.18V168.18ZM2796.67 195.575C2798.76 181.118 2787.55 168.18 2772.95 168.18V216.18C2758.32 216.18 2747.07 203.202 2749.16 188.7L2796.67 195.575ZM2719.69 1049.38C2714.21 1110.05 2625.58 1110.05 2620.1 1049.38L2667.91 1045.06C2668 1046.08 2668.21 1046.47 2668.22 1046.5C2668.24 1046.53 2668.24 1046.52 2668.22 1046.5C2668.2 1046.48 2668.19 1046.47 2668.19 1046.48C2668.23 1046.5 2668.78 1046.88 2669.9 1046.88C2671.01 1046.88 2671.57 1046.5 2671.6 1046.48C2671.6 1046.47 2671.59 1046.48 2671.57 1046.5C2671.55 1046.52 2671.56 1046.53 2671.57 1046.5C2671.58 1046.47 2671.8 1046.08 2671.89 1045.06L2719.69 1049.38ZM2590.83 188.615C2592.92 203.147 2581.65 216.18 2566.94 216.18V168.18C2552.4 168.18 2541.25 181.07 2543.32 195.44L2590.83 188.615Z" fill="#A4A4A4" mask="url(#path-23-outside-1_182_1484)"/>
                          <path :fill="`#${this.draw.style.color}` || '#FFB000'" d="M2741.33 174.333C2741.33 213.22 2709.8 244.744 2670.91 244.744C2632.03 244.744 2600.5 213.22 2600.5 174.333C2600.5 135.447 2632.03 103.923 2670.91 103.923C2709.8 103.923 2741.33 135.447 2741.33 174.333Z"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M2672.21 72.781C2671.48 72.7656 2670.74 72.7578 2670 72.7578C2612.56 72.7578 2566 119.443 2566 177.032C2566 182.124 2566.36 187.131 2567.07 192.028C2567.08 192.108 2567.02 192.18 2566.94 192.18C2566.86 192.18 2566.8 192.247 2566.8 192.325L2644 1047.22C2645.51 1063.99 2659.25 1071.85 2672.21 1070.79V72.781Z" fill="white" fill-opacity="0.5"/>
                        </svg>
                      </div>
                        <!-- <object class="wheel position-absolute" type="image/svg+xml" :data="WheelImg"></object> -->
                      <div class="canvas-container d-flex rounded-circle w-100 h-100" @click="onClickStartWheel">
                        <canvas ref="canvas" class="canvas-wheel bg-white rounded-circle w-100" ></canvas>
                        <button
                          class="wheel-btn p-0 m-0 position-absolute d-flex align-items-center justify-content-center btn position-relative text-white"
                          :style="`background: #${draw.style.color}; opacity: ${isDrawing? 0 : 1};`"
                          @click="onClickStartWheel"
                        >
                          {{ $t('draw.start') }}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="desc">{{ $t('draw.startGame') }}<br>{{ $t('draw.shotDesc') }}</div>
                </template>

                <div class="token monospace"> {{ $t('draw.serial') }} {{ draw.id }}</div>

                <i18n-picker></i18n-picker>
              </div>
              <div class="draw-step draw-step-3" v-else-if="currentStep === 3" key="draw-step-3">
                <template v-if="!draw.needInfo">
                  <div class="title">{{ draw.title }}</div>
                  <div class="desc">{{ draw.action.desc }}</div>
                  <a class="btn" :href="draw.action.url">{{ $t('draw.go') }} <span class="icon material-icons">arrow_forward</span></a>
                </template>
                <template v-else>
                  <div class="title">{{ draw.title }}</div>
                  <div v-if="draw.result.prize" class="desc">{{ $t('draw.fillInformationByPrize', { name: draw.result.name }) }}</div>
                  <div v-else class="desc">{{ $t('draw.fillInformation') }}</div>
                  <div class="inputs"></div>
                  <div class="caption">{{ $t('draw.reminderDesc') }}</div>
                  <div v-html="$t('draw.acceptedOfTerms')" class="terms"></div>
                  <button class="btn" v-on:click="currentStep = 2">{{ $t('common.submit') }} <span class="icon material-icons">arrow_forward</span></button>
                </template>

                <i18n-picker></i18n-picker>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal"
      v-if="showModal"
    >
      <div class="lottie" ref="lottie" />
      <div class="overlay"></div>
      <transition name="content">
        <div class="content" v-show="showModalContent">
          <div class="played" v-if="draw.played">{{ $t('draw.played') }}</div>
          <template v-if="draw.result.prize">
            <div class="title">{{ $t('draw.congratulation') }}</div>
            <div
              class="prize"
              :style="{
                background: draw.style.color ? '0' : null,
                backgroundColor: `#${draw.style.color}` || null,
              }">
              <div class="image"><img :src="draw.result.image"></div>
              <div class="name">{{ draw.result.name }}</div>
            </div>
          </template>
          <template v-else>
            <div class="title">{{ $t('draw.sorry') }}</div>
            <div class="oh-no-emoji" />
            <div class="oh-no">{{ $t('draw.sorryDesc') }}</div>
          </template>
          <button class="btn" v-on:click="showModal = false; currentStep = 3">{{ $t('common.next') }} <span class="icon material-icons">arrow_forward</span></button>
          <div class="token monospace">{{ $t('draw.serial') }} {{ draw.id }}</div>
        </div>
      </transition>
    </div>

    <cell-input
      v-if="showCellInput"
      :title="$t('draw.fillInYourMobileNumber')"
      :country="country"
      v-on:close="showCellInput = false"
      v-on:submit="claimDraw"
    ></cell-input>

    <img ref="lose-dom" class="d-none" src="../../assets/img/draw/wheel/lose.svg">
  </div>
</template>

<script>
import _ from 'lodash';
import 'swiper/css/swiper.css';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import { mapState, mapMutations } from 'vuex';
import I18nPicker from '@/components/I18nPicker.vue';

import swal from 'sweetalert2';
import lottie from 'lottie-web';
import Axios from '../helpers/axios';
import CellInput from '../components/CellInput.vue';
import Loader from '../components/Loader.vue';

export default {
  name: 'Draw',
  components: {
    Loader,
    Swiper,
    SwiperSlide,
    CellInput,
    I18nPicker,
  },
  directives: {
    swiper: directive,
  },
  computed: {
    ...mapState([
      'loader',
    ]),
    hasSerial() {
      return this.$route.params.serial;
    },
  },
  data() {
    return {
      currentStep: 1,

      swiperOptions: {
        slidesPerView: 'auto',
        spaceBetween: 40,
        centeredSlides: true,
        loop: true,
        autoplay: {
          delay: 2500,
        },
      },

      brand: {
        name: '',
        logo: '',
      },

      gameStarted: false,
      reveal: false,
      showModal: false,
      showModalContent: false,

      // type === 1
      //
      canvas: null,
      ctx: null,
      isDrawing: false,
      originOffset: null,
      totalPercent: 0,

      // type === 3
      swapperBg: null,
      swapperTimer: null,
      showStop: true,

      // type === 4
      losePrize: {
        name: this.$i18n.t('draw.thankyou'),
        image: 'lose-img',
        token: 'lose-prize',
      },
      preDeg: 0,
      preLocateAngle: 0,
      offsetAngle: 0,
      draw: {
        id: null,
        played: false,
        type: 2,
        theme: 1,
        title: '',
        descImage: null,
        desc: '',
        image: null,
        needInfo: true,
        prizes: [],
        result: {
          prize: true,
          name: '',
          image: '',
        },
        action: {
          desc: '',
          url: '',
        },
        style: {
          bg: null,
          color: null,
        },
      },
      filterPrizes: [],
      lottieAnim: null,

      showCellInput: false,
      country: 'TW',
    };
  },
  created() {
    window.addEventListener('resize', this.resizeThrottler);
  },
  mounted() {
    this.getDraw(this.$route.params.token, this.$route.params.serial, this.$route.query.sid || null);
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeThrottler);
  },
  methods: {
    ...mapMutations([
      'setLoader',
    ]),
    hexToRgb(hex) {
      const bigint = parseInt(hex, 16);
      /* eslint-disable no-bitwise */
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;
      /* eslint-enable no-bitwise */

      return `${r} , ${g}, ${b}`;
    },
    goPlay() {
      if (!this.$route.params.serial) {
        this.showCellInput = true;
      } else if (this.draw.played) {
        this.reveal = true;
      } else {
        this.currentStep = 2;
      }
    },
    async getDraw(token, serial, store) {
      const data = {
        ...this.$route.query,
        token,
      };

      if (serial) data.serial = serial;
      if (store) data.store_id = store; delete data.sid;
      try {
        const response = await Axios({
          method: 'post',
          url: '/v2/draw_w/get',
          data,
        });

        if (response.data.code !== 500) {
          if (response.data.msg) {
            swal.fire({
              text: response.data.msg,
              confirmButtonText: this.$i18n.t('common.ok'),
            });
          }

          return;
        }

        this.draw.id = response.data.data.id || null;
        this.brand.name = response.data.data.brand_name;
        this.brand.logo = response.data.data.image_logo;
        this.draw.type = response.data.data.type;
        this.draw.title = response.data.data.title;
        this.draw.desc = response.data.data.desc;
        this.draw.theme = response.data.data.theme;
        this.draw.prizes = response.data.data.prizes;
        this.draw.played = response.data.data.played;
        this.draw.needInfo = response.data.data.need_info;
        this.draw.descImage = response.data.data.desc_image || null;
        this.draw.style.bg = response.data.data.bg || null;
        this.draw.style.color = response.data.data.color || null;

        if (response.data.data.result) {
          this.draw.result.prize = response.data.data.result.prize;
          this.draw.result.name = response.data.data.result.name;
          this.draw.result.image = response.data.data.result.image;
          this.draw.result.token = response.data.data.result.token;

          this.draw.action.desc = response.data.data.result.action_msg;
          this.draw.action.url = response.data.data.result.action_url;
        }
        if (response.data.data.image) this.draw.image = response.data.data.image;

        if (this.draw.type === 4 && this.hasSerial) {
          const observer = new MutationObserver((() => {
            const canvasWheelDom = document.querySelector('.canvas-wheel');

            if (canvasWheelDom) {
              observer.disconnect();
              this.drawCanvasWheel();
            }
          }));

          const options = {
            childList: true,
            attributes: true,
            characterData: true,
            subtree: true,
            attributeOldValue: true,
            characterDataOldValue: true,
          };

          observer.observe(document, options);
        }
        this.$nextTick((() => {
          this.setLoader(false);
        }));
      } catch (error) {
        //
      }
    },
    async claimDraw(cell) {
      const data = {
        ...this.$route.query,
        token: this.$route.params.token,
        cell,
      };

      data.store_id = this.$route.query.sid; delete data.sid;

      try {
        const response = await Axios({
          method: 'post',
          url: '/v2/draw_w/claim',
          data,
        });
        if (response.data.code !== 500) {
          if (response.data.msg) {
            swal.fire({
              text: response.data.msg,
              confirmButtonText: this.$i18n.t('common.ok'),
            });
          }

          return;
        }

        await this.$router
          .push({
            name: 'Draw',
            params: {
              serial: response.data.data.serial,
            },
            query: {
              store: this.$route.query.sid,
            },
          });

        this.showCellInput = false;

        await this.getDraw(this.$route.params.token, this.$route.params.serial, this.$route.query.sid);

        this.$nextTick(() => {
          if (this.draw.played) {
            this.reveal = true;
          } else {
            this.currentStep = 2;
          }
        });
      } catch (error) {
        //
      }
    },
    playDraw() {
      Axios({
        method: 'post',
        url: '/v2/draw_w/play',
        data: {
          id: this.draw.id,
          ...this.$route.query,
        },
      })
        .then((response) => {
          if (response.data.code === 500) {
            if (response.data.data.action_msg) this.draw.action.desc = response.data.data.action_msg;
            if (response.data.data.action_url) this.draw.action.url = response.data.data.action_url;
          }
        });
    },
    flipCardImage(index) {
      if (typeof this.draw.image === 'object') {
        return this.draw.image[index - 1];
      } else if (this.draw.image) {
        return this.draw.image;
      }

      return null;
    },
    onClickFlipCard(index) {
      if (!this.gameStarted) {
        this.$refs.flipCard[index].classList.add('flipped');

        this.playDraw();
        this.gameStarted = true;
        setTimeout(() => { this.reveal = true; }, 1000);
      }
    },
    onClickStartWheel() {
      if (this.isDrawing) {
        return;
      }
      const isWin = this.draw.result && this.draw.result.prize;

      this.isDrawing = true;

      const winning = this.draw.result;
      const perAngle = 360 / (this.filterPrizes.length);

      const winningIndex = this.filterPrizes.map(prize => prize.token).findIndex(prize => (prize === (isWin ? winning.token : this.losePrize.token)));
      const turns = _.random(5, 8);
      const safeAngle = 5;

      const locateAngle = (winningIndex * perAngle) + _.random(safeAngle, perAngle - safeAngle);

      this.preDeg += (((this.preDeg ? this.offsetAngle : 0) + this.preLocateAngle) + (turns * 360)) - this.offsetAngle - locateAngle;

      this.canvas.style.transitionDuration = '6s';
      this.canvas.style.transitionTimingFunction = 'cubic-bezier(0.3, 0, 0, 1)';
      this.canvas.style.transform = `rotate(${this.preDeg}deg)`;

      this.preLocateAngle = locateAngle;
      this.preLocateAngle = locateAngle;
      this.playDraw();
      setTimeout(() => {
        this.reveal = true;
      }, 6000);
    },
    startSwapImage() {
      this.gameStarted = true;
      const images = [];

      this.draw.prizes.forEach((prize) => {
        images.push(prize.image);
      });

      let index = images.length - 1;

      this.swapperTimer = setInterval(() => {
        if (index === images.length - 1) {
          index = 0;
        } else {
          index += 1;
        }

        this.swapperBg = images[index];
      }, 100);
    },
    stopSwapImage() {
      if (this.swapperTimer) {
        clearInterval(this.swapperTimer);
      }
    },
    onClickSwapperStop() {
      this.showStop = false;

      this.stopSwapImage();

      const images = [];

      this.draw.prizes.forEach((prize) => {
        images.push(prize.image);
      });

      let index = images.length - 1;

      let step;

      for (step = 0; step < 4; step += 1) {
        // eslint-disable-next-line no-loop-func
        setTimeout(() => {
          if (index === images.length - 1) {
            index = 0;
          } else {
            index += 1;
          }

          this.swapperBg = images[index];
        }, 100 + (75 * step * step)); // 175, 400, 775, 1300
      }

      setTimeout(() => {
        this.swapperBg = this.draw.result.image;
      }, 1975);

      setTimeout(() => {
        this.reveal = true;
      }, 2000);
    },
    canvasScratchOffTicket() {
      this.canvas = this.$refs.canvas;

      if (!this.canvas.getContext) return;

      this.ctx = this.canvas.getContext('2d');

      this.canvasImage();

      this.canvas.addEventListener('mousedown', this.handleDrawingStart, false);
      this.canvas.addEventListener('mousemove', this.handleDrawingInProgress, false);
      this.canvas.addEventListener('mouseup', this.handleDrawingEnd, false);

      this.canvas.addEventListener('touchstart', this.handleDrawingStart, false);
      this.canvas.addEventListener('touchmove', this.handleDrawingInProgress, false);
      this.canvas.addEventListener('touchend', this.handleDrawingEnd, false);
    },
    drawCanvasWheel() {
      this.canvas = this.$refs.canvas;

      const width = 286;
      const height = 286;
      const ratio = (window.devicePixelRatio || 1) * 2;
      this.canvas.width = width * ratio;
      this.canvas.height = height * ratio;

      const mainRgb = {
        r: parseInt(this.draw.style.color.slice(0, 2), 16),
        g: parseInt(this.draw.style.color.slice(2, 4), 16),
        b: parseInt(this.draw.style.color.slice(4, 6), 16),
      };

      if (!this.canvas.getContext) return;

      this.ctx = this.canvas.getContext('2d');
      this.ctx.scale(ratio, ratio);

      this.filterPrizes = this.getRandomPrizes(8);
      const totalLength = this.filterPrizes.length;
      this.offsetAngle = (90 - (360 / totalLength / 2)) + (360 / totalLength);

      const isEven = totalLength % 2 === 0;

      const canvasDrawImg = (img, name, angle) => {
        const imgWidth = 52;
        const fontSize = 12;
        const textGapToTop = totalLength <= 4 ? 25 : 12;
        const imgGapToText = totalLength <= 4 ? 7 : 5;
        const textMaxLength = totalLength <= 4 ? fontSize * 11 : fontSize * 7;

        this.ctx.save();

        this.ctx.translate(width / 2, height / 2);
        this.ctx.rotate(-((360 - this.offsetAngle - angle) * Math.PI) / 180);

        this.ctx.textAlign = 'center';
        this.ctx.font = `bold ${fontSize}px 'Montserrat', 'PingFangTC-Regular', 'PingFangHK-Regular', 'PingFangSC-Regular', 'Noto Sans TC', sans-serif`;
        this.ctx.fillStyle = '#5A5A5A';
        this.ctx.textBaseline = 'top';
        this.ctx.fillText(this.fittingString(name, textMaxLength), 0, -((height / 2) - textGapToTop));

        // 圖示進行進行圓形切割
        this.ctx.beginPath();
        this.ctx.arc(0, -((height / 2) - (imgWidth / 2) - textGapToTop - fontSize - imgGapToText), imgWidth / 2, 0, Math.PI * 2, false);
        this.ctx.clip();

        // 產生圖示
        this.ctx.drawImage(img, 0 - (imgWidth / 2), -((height / 2) - textGapToTop - fontSize - imgGapToText), imgWidth, imgWidth);

        this.ctx.restore();
      };

      for (let i = 0; i < totalLength; i += 1) {
        const current = this.filterPrizes[i];
        const angle = (((360 / totalLength) * i) + (360 / totalLength / 2));

        this.ctx.save();
        this.ctx.beginPath();
        this.ctx.translate(width / 2, height / 2);
        this.ctx.moveTo(0, 0);
        this.ctx.rotate((angle * Math.PI) / 180);
        this.ctx.arc(0, 0, height / 2, 0, (2 * Math.PI) / totalLength, false);
        this.ctx.lineTo(0, 0);

        if (isEven) {
          if (i % 2 === 0) {
            this.ctx.fillStyle = 'white';
          } else {
            this.ctx.fillStyle = `rgba(${mainRgb.r}, ${mainRgb.g}, ${mainRgb.b}, 0.2)`;
          }
        } else if (i % 3 === 0) {
          this.ctx.fillStyle = 'white';
        } else if (i % 3 === 1) {
          this.ctx.fillStyle = `rgba(${mainRgb.r}, ${mainRgb.g}, ${mainRgb.b}, 0.15)`;
        } else {
          this.ctx.fillStyle = `rgba(${mainRgb.r}, ${mainRgb.g}, ${mainRgb.b}, 0.3)`;
        }

        this.ctx.fill();
        this.ctx.restore();


        if (current.image === 'lose-img') {
          const loseImg = this.$refs['lose-dom'];
          canvasDrawImg(loseImg, current.name, angle);
        } else {
          const img = new Image();
          img.onload = () => {
            canvasDrawImg(img, current.name, angle);
          };
          img.src = current.image;
        }
      }

      this.canvas.style.transform = `rotate(-${this.offsetAngle}deg)`;
    },
    getRandomPrizes(maxPrizeNum = 1) {
      const isWin = this.draw.result && this.draw.result.prize;

      let newArr = [];
      let tempArr = [];
      if (isWin) {
        tempArr = _.filter(this.draw.prizes, prize => prize.token !== this.draw.result.token);
      } else {
        tempArr = _.cloneDeep(this.draw.prizes);
      }

      if (tempArr.length >= maxPrizeNum) {
        for (let i = 0; i < maxPrizeNum - 1; i += 1) {
          const randomIndex = Math.floor(_.random(0, 1, true) * tempArr.length);
          const selectedValue = tempArr.splice(randomIndex, 1)[0];
          newArr.push(selectedValue);
        }
      } else {
        newArr = tempArr;
      }

      const toSetPrize = isWin ? {
        name: this.draw.result.name,
        image: this.draw.result.image,
        token: this.draw.result.token,
      } : this.losePrize;

      newArr.splice(_.random(0, newArr.length - 1), 0, toSetPrize);

      if (newArr.length === 1) {
        newArr.push(this.losePrize);
      }
      return newArr;
    },
    fittingString(str, maxWidth) {
      let strWidth = this.ctx.measureText(str).width;
      const ellipsis = '…';
      const ellipsisWidth = this.ctx.measureText(ellipsis).width;
      if (strWidth <= maxWidth || maxWidth <= ellipsisWidth) {
        return str;
      }
      let newStr = '';
      let length = str.length;
      while (strWidth >= maxWidth - ellipsisWidth && length - 1 > 0) {
        length -= 1;
        newStr = str.slice(0, length);
        strWidth = this.ctx.measureText(newStr).width;
      }
      return newStr + ellipsis;
    },
    canvasImage() {
      const canvasBox = document.querySelector('.canvas-box');
      const img = new Image();
      const url = 'https://images.unsplash.com/photo-1638976352303-3b1208f94079?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1110&q=80';

      img.onload = () => {
        this.canvas.width = canvasBox.clientWidth;
        this.canvas.height = canvasBox.clientHeight;
        this.ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, canvasBox.clientWidth, canvasBox.clientHeight);
      };
      img.crossOrigin = 'Anonymous';
      img.src = url;
    },
    handleDrawingStart(e) {
      e.preventDefault();

      const mousePos = this.getMousePositionOnCanvas(e);

      this.ctx.beginPath();
      this.ctx.moveTo(mousePos.x, mousePos.y);
      this.ctx.lineWidth = 50;
      this.ctx.lineCap = 'round';
      this.ctx.lineJoin = 'round';
      this.ctx.fill();

      this.isDrawing = true;
    },
    handleDrawingInProgress(e) {
      e.preventDefault();

      const mousePos = this.getMousePositionOnCanvas(e);
      const imgData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
      const pixels = imgData.data;
      const transPixels = [];

      if (this.isDrawing) {
        this.ctx.globalCompositeOperation = 'destination-out';
        this.ctx.lineTo(mousePos.x, mousePos.y);
        this.ctx.stroke();

        for (let i = 0; i < pixels.length; i += 4) {
          if (pixels[i + 3] < 128) transPixels.push(pixels[i + 3]);
        }

        this.totalPercent = Number(((transPixels.length / (pixels.length / 4)) * 100).toFixed(0));
      }
    },
    handleDrawingEnd(e) {
      e.preventDefault();

      if (this.isDrawing) this.ctx.stroke();

      this.isDrawing = false;
    },
    getMousePositionOnCanvas(e) {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
        const rect = e.target.getBoundingClientRect();
        const x = e.targetTouches[0].pageX - rect.left;
        const y = e.targetTouches[0].pageY - rect.top;

        return { x, y };
      }

      return { x: e.offsetX, y: e.offsetY };
    },
    resizeThrottler() {
      let resizeTimeout = null;

      if (!resizeTimeout && this.currentStep === 2 && this.draw.type === 1) {
        resizeTimeout = setTimeout(() => {
          resizeTimeout = null;
          this.canvasImage();
        }, 66);
      }
    },
  },
  watch: {
    reveal(value) {
      if (value) {
        this.showModal = true;

        if (this.draw.result.prize) {
          this.$nextTick(() => {
            lottie.destroy();
            this.lottieAnim = lottie.loadAnimation({
              container: this.$refs.lottie,
              renderer: 'svg',
              loop: true,
              autoplay: true,
              path: 'https://assets7.lottiefiles.com/packages/lf20_4sg4nb.json',
              rendererSettings: {
                preserveAspectRatio: 'xMidYMin slice',
              },
            });
          });
        }
      }
    },
    showModal(value) {
      this.$nextTick(() => {
        this.showModalContent = value;
      });
    },
    currentStep(step) {
      if (step === 2 && this.draw.type === 1) {
        setTimeout(() => { this.canvasScratchOffTicket(); }, 50);
      }

      if (step === 2 && this.draw.type === 3) {
        this.swapperBg = this.draw.prizes[0].image;

        setTimeout(() => { this.startSwapImage(); }, 1000);
      }

      if (step === 2 && this.draw.type === 4) {
        // move function drawCanvasWheel into function getDraw and listen to class canvas-wheels showup
      }
    },
    totalPercent(percent) {
      if (percent >= 50) this.reveal = true;
    },
  },
};
</script>

<style lang="sass" scoped>
$cb: cubic-bezier(.4, 0, .2, 1)

.draw-view
  width: 100%
  height: 100%
  position: relative

  color: white

.background-container
  width: 100%
  height: 100%
  position: absolute
  z-index: -1

  background-color: black

  .background-stretch
    height: 100%

  .background
    width: 100%
    height: 100%

    background-size: auto 100%
    background-position-x: 0%

    transition: background-position 1s $cb

    @media only screen and (min-width : 992px)
      border-radius: 8px

    &__step-2
      background-position-x: calc(100% / 3)

    &__step-3
      background-position-x: calc(100% / 3 * 2)

.header
  position: absolute
  top: 0
  right: 0
  left: 0
  padding: 8px 0

  background-image: linear-gradient(180deg, rgba(0, 0, 0, .25) 0%, rgba(0, 0, 0, 0) 100%)

  .steps
    margin: 0 8px 8px

    display: flex
    justify-content: space-between

  .bar
    width: calc(33.333% - 4px)
    height: 4px

    border-radius: 4px

    background-color: rgba(255, 255, 255, .25)

    &__is-active
      background-color: white

  .info
    margin: 0 8px
    display: flex
    justify-content: space-between
    align-items: center

  .brand
    display: flex
    justify-content: space-between
    align-items: center
    flex-grow: 1

  .logo
    width: 32px
    height: 32px
    overflow: hidden
    position: relative
    margin-right: 8px

    border-radius: 100%

    &::after
      position: absolute
      top: 0
      right: 0
      bottom: 0
      left: 0
      z-index: 2

      border: .5px solid rgba(0, 0, 0, .1)
      border-radius: 100%

      content: ''

    img
      width: 100%
      height: 100%

  .name
    flex-grow: 1
    font-weight: bold

    line-height: 1

  .powered-by
    svg
      margin: 0 8px

.main
  text-align: center
  height: 100%
  overflow-x: hidden
  overflow-y: auto

  .main-stretch
    height: 100%

  .draw-step
    min-height: 100%
    padding: 76px 0 32px
    display: flex
    flex-direction: column
    justify-content: center

    .title
      padding: 0 16px
      margin-bottom: 16px

      font-size: 2.5rem
      font-weight: bold

    .btn
      appearance: none
      padding: 16px 24px
      margin: 8px auto
      display: flex
      align-items: center

      background-color: white

      border: none
      border-radius: 99px

      font-weight: bold
      font-size: 1.125em

      .icon
        margin-left: 8px
        transform: translateY(-1px)

    .terms
      padding: 0 16px
      margin-bottom: 16px

      font-size: 0.75rem

      a
        color: currentColor
        text-decoration: underline

    .token
      padding: 0 16px
      font-size: 0.75rem
      color: rgba(255, 255, 255, .5)

  .draw-step-1
    .desc
      padding: 0 16px
      margin-bottom: 24px

      font-size: 1.125em

    .desc-image
      padding: 0 16px
      margin-bottom: 24px

      border-radius: 8px

      width: 100%

    .subtitle
      font-size: 1.5rem

    .prizes
      margin-bottom: 24px

      .prizes-wrapper
        padding-bottom: 8px

      .prize
        width: calc(100% / 4 * 2)
        padding: 4px

        border-radius: 16px

      .image img
        border-radius: 12px
        width: 100%
        height: auto

        user-select: none

      .name
        padding: 8px 16px

        font-weight: bold

  .draw-step-2
    .game
      margin: 8px 24px 24px
    .scratch-off-ticket
      display: flex
      justify-content: center
      align-items: center

      .overlay
        width: 100%

        &-position
          position: relative
          padding-top: calc(100% * 1)

      .canvas-box
        position: absolute
        top: 0
        right: 0
        bottom: 0
        left: 0
        border-radius: 4px
        z-index: 2
        margin: 16px
        background-size: cover
        background-position: center center

        canvas
          position: absolute
          top: 0
          left: 0
          max-width: 100%
          height: auto
          border-radius: 4px

      .ticket-background
        position: absolute
        top: 0
        right: 0
        bottom: 0
        left: 0

    .flip-cards
      display: flex
      flex-wrap: wrap
      justify-content: space-between

      .flip-card
        position: relative
        width: calc(50% - 4px)

        perspective: 1000px

        cursor: pointer

        &:nth-child(1),
        &:nth-child(2)
          margin-bottom: 8px

        &::before
          padding-top: 100%
          content: ''
          display: table

        &.flipped
          .inner
            transform: rotateY(-180deg)

        .inner
          position: absolute
          top: 0
          right: 0
          bottom: 0
          left: 0
          width: 100%
          height: 100%

          transform-style: preserve-3d
          perspective: 1000px
          transition: transform .75s $cb

        .front,
        .back
          position: absolute
          top: 0
          right: 0
          bottom: 0
          left: 0
          width: 100%
          height: 100%

          border-radius: 16px

          background-color: white
          background-size: cover
          background-position: center

          backface-visibility: hidden

        .front
          background-image: linear-gradient(135deg, #FFFFFF 0%, #E9E9E9 100%)

          display: flex
          justify-content: center
          align-items: center

        .back
          transform: rotateY(180deg)

    .swapper
      background-color: white
      border-radius: 24px
      position: relative

      &::before
        padding-top: 100%
        display: table
        content: ''

      .stop
        position: absolute
        top: 50%
        left: 50%
        border-radius: 999px
        width: 80px
        height: 80px

        border: 1px solid #333

        text-align: center
        font-weight: bold
        font-size: 1.2081rem

        appearance: none
        outline: 0
        transform: translate(-50%, -50%)
    .wheel-container
      margin: 20px auto 32px
      width: 90%
      .wheel
        top: -4.7vw
        width: 100%
        left: 50%
        transform: translateX(-50%)
        z-index: 40
        @media only screen and (min-width : 566px)
          top: -4.8vw
        @media only screen and (min-width : 768px)
          top: -2.3vw
        @media only screen and (min-width : 992px)
          top: -1.5vw
      .canvas-container
        position: relative
        padding: 5.4vw
        box-shadow: 12px 12px 0px 0px #00000026
        @media only screen and (min-width : 566px)
          padding: 5.8vw
        @media only screen and (min-width : 768px)
          padding: 2.7vw
        @media only screen and (min-width : 992px)
          padding: 1.7vw
        &::after
          content: ''
          position: absolute
          width: 100%
          height: 100%
          top: 0
          left: 0
          z-index: 100
          cursor: pointer
          border-radius: 50%
    .wheel-btn
      top: 50%
      left: 50%
      transform: translate(-50%, -50%)
      transition: all 0.3s
      width: 17vw
      height: 17vw
      font-size: 4vw
      z-index: 50
      @media only screen and (min-width : 768px)
        width: 8vw
        height: 8vw
        font-size: 2vw
      @media only screen and (min-width : 992px)
        width: 6vw
        height: 6vw
        font-size: 1.4vw
    .desc
      margin-bottom: 16px

      font-size: 1.125em
      font-weight: bold

  .draw-step-3
    .desc
      padding: 0 16px

      font-size: 1.125em
      font-weight: bold

    .caption
      margin: 16px 0
      font-size: 0.75rem

.modal
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  display: flex
  align-items: center
  z-index: 1040

  transition: all .25s ease

  .lottie
    position: fixed
    top: 0
    right: 0
    bottom: 0
    left: 0
    z-index: 1060

    pointer-events: none

  .overlay
    position: fixed
    top: 0
    right: 0
    bottom: 0
    left: 0
    z-index: 1040
    opacity: .7

    background-image: linear-gradient(0deg, rgba(44,43,43,0.95) 0%, rgba(33,32,32,0.95) 100%)

  .content
    position: relative
    width: 100%
    max-height: 90%
    z-index: 1050
    margin: 0 auto
    padding: 24px 16px
    overflow-x: hidden
    overflow-y: auto

    border-radius: 24px

    background-color: white

    -webkit-overflow-scrolling: touch

    color: #333
    text-align: center

    @media only screen and (min-width : 768px)
      max-width: 475px

    .played
      margin-bottom: 16px
      padding: 0 16px
      color: rgba(0, 0, 0, .5)

    .title
      margin-bottom: 16px

      font-size: 2.5rem

    .prize
      margin: 24px auto
      width: 75%
      max-width: 300px
      padding: 4px

      border-radius: 16px

      animation-name: tada
      animation-duration: 2s
      animation-fill-mode: both
      animation-iteration-count: infinite

    .image img
      border-radius: 12px
      width: 100%
      height: auto

    .name
      padding: 16px

      font-weight: bold

    .oh-no-emoji
      &::before
        content: ''
        font-size: 4.5rem
        animation-name: oh-no-emojis
        animation-duration: 5s
        animation-iteration-count: infinite

    .oh-no
      margin-bottom: 32px

      font-weight: bold
      font-size: 1.125em
      color: rgba(0, 0, 0, .5)

    .btn
      appearance: none
      padding: 16px 24px
      margin: 8px auto 16px
      display: flex
      align-items: center

      background-color: white

      border: none
      border-radius: 99px

      font-weight: bold
      font-size: 1.125em

      .icon
        margin-left: 8px
        transform: translateY(-1px)

    .token
      margin-top: 16px
      padding: 0 16px
      font-size: 0.75rem
      color: rgba(0, 0, 0, .25)

.slide-enter-active
  transition: transform 1s $cb, opacity 1s $cb

.slide-enter
  opacity: 0
  transform: translateX(25%)

.slide-leave-active
  transition: transform 0s $cb, opacity 0s $cb

.slide-leave
  opacity: 0

.content-enter-active,
.content-leave-active
  transition: opacity .5s $cb, transform .5s $cb

.content-enter,
.content-leave-to
  opacity: 0
  transform: translateY(50%) scale(.75)

@keyframes tada
  from
    transform: scale3d(1, 1, 1)

  5%,
  10%
    transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg)

  15%,
  25%,
  35%,
  45%
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg)

  20%,
  30%,
  40%
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg)

  50%,
  to
    transform: scale3d(1, 1, 1)

@keyframes oh-no-emojis
  from
    content: '\01F972'

  10%
    content: '\01F635\200D\01F4AB'

  20%
    content: '\01F629'

  30%
    content: '\01F624'

  40%
    content: '\01F613'

  50%
    content: '\01F62D'

  60%
    content: '\01F927'

  70%
    content: '\01F976'

  80%
    content: '\01F97A'

  90%
    content: '\01F92C'

  100%
    content: '\01F972'
</style>

<style lang="sass" scoped>
// Theme 1：熱鬧
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@900&family=Noto+Sans+TC:wght@900&display=swap')

.draw-view
  --accent--color: 161, 26, 225

.draw-view__theme-1
  .background
    border-color: #FF5249
    background-image: url(../../assets/img/draw/bg-1.jpg)

  .main
    .draw-step
      .title
        text-shadow: 4px 4px 0 rgba(255, 255, 255, .25)
        font-family: 'Montserrat', 'Noto Sans TC'
        font-weight: 900
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;

      .btn
        color: rgba(var(--accent--color), 1)

        outline: 0

        &:active
          transform: scale(.95)

    .draw-step-1
      .subtitle
        margin-bottom: 16px

        font-family: 'Montserrat', 'Noto Sans TC'
        font-weight: 900
        color: rgba(var(--accent--color), 1)

      .prizes
        .prize
          box-shadow: 8px 8px 0 0 white

          background-image: linear-gradient(135deg, #FF6C4C 0%, #F33986 100%)

    .draw-step-2
      .flip-card
        &:nth-child(1)
          .front
            background-image: url(../../assets/img/draw/flip-card/theme-1-1.jpg)

        &:nth-child(2)
          .front
            background-image: url(../../assets/img/draw/flip-card/theme-1-2.jpg)

        &:nth-child(3)
          .front
            background-image: url(../../assets/img/draw/flip-card/theme-1-3.jpg)

        &:nth-child(4)
          .front
            background-image: url(../../assets/img/draw/flip-card/theme-1-4.jpg)

      .swapper
        .stop
          border-width: 3px
          border-color: white

          background-color: rgba(var(--accent--color), 1)

          color: white

  .modal
    .content
      .title
        color: rgba(var(--accent--color), 1)
        text-shadow: 4px 4px 0 rgba(var(--accent--color), .1)
        font-family: 'Montserrat', 'Noto Sans TC'
        font-weight: 900

      .prize
        background-image: linear-gradient(135deg, #FF6C4C 0%, #F33986 100%)

        color: white

      .btn
        background-color: rgba(var(--accent--color), 1)
        box-shadow: 8px 8px 0 0 rgba(var(--accent--color), .1)

        color: white
</style>
